<template>
  <div class="grid-y flex-grow">
    <div
      class="cell"
      v-if="customer">
      <UserProfile
        :payload="customer"
        :pins="pins"/>
    </div>
    <div class="cell">
      <div class="flex flex-row items-center justify-between mt-4 py-4 px-8">
        <span class="text-danger text-16px leading-18px font-bold">
          {{ $delve(object, 'blockingReason') }}
        </span>
        <button
          class="btn btn-sm btn-outline-primary"
          @click="$router.push({
            name: 'objects',
          })">Назад</button>
      </div>
    </div>
  </div>
</template>

<script>
import _ from 'lodash';
import moment from 'moment';
import { mapGetters, mapActions } from 'vuex';
import UserProfile from '@/components/User/UserProfile.vue';

export default {
  components: {
    UserProfile,
  },
  computed: {
    ...mapGetters({
      customersGetter: 'customers/customers',
      objectsGetter: 'objects/object',
    }),
    id() {
      return _.get(this.$route, 'params.id');
    },
    object() {
      if (this.id) {
        return this.objectsGetter(this.id);
      }
      return null;
    },
    customerId() {
      return _.get(this.object, 'customer.id');
    },
    customer() {
      if (this.customerId) {
        return this.customersGetter(this.customerId);
      }
      return null;
    },
    pins() {
      return [
        {
          title: 'Создано объектов',
          data: this.$numeral(this.$delve(this.customer, 'subjectsCount')).format('0,0'),
        },
        {
          title: 'Общая сумма заказов',
          data: this.$numeral(parseFloat(this.$delve(this.object, 'totalOrderPrice'))).format('0,0 $'),
        },
        {
          title: 'Дата последнего заказа',
          data: this.$options.filters.date(this.$delve(this.object, 'lastOrderDate')),
        },
        {
          title: 'Сумма последнего заказа',
          data: this.$numeral(parseFloat(this.$delve(this.customer, 'lastOrderPrice'))).format('0,0 $'),
        },
      ];
    },
  },
  filters: {
    date(s) {
      const date = moment(s);
      if (date.isValid()) {
        return date.format('DD.MM.YYYY');
      }
      return null;
    },
  },
  methods: {
    ...mapActions({
      fetchCustomer: 'customers/ACT_FETCH_CUSTOMER',
    }),
  },
  watch: {
    customerId: {
      handler(value) {
        if (value) {
          this.fetchCustomer(value);
        }
      },
      immediate: true,
    },
  },
};
</script>
